export const RECEIVE_RECENT_UPLOADS = 'RECEIVE_RECENT_UPLOADS';
export const SORT_RECENT_UPLOADS = 'SORT_RECENT_UPLOADS';
